/**
 * Money for usage rates, which arrive as integer minor units (cents for USD,
 * paise for INR).
 *
 * Rates land well below a cent in some currencies, so a fixed 2 d.p. would
 * render several distinct rates as the same "$0.01" — the fraction widens only
 * when the minor-unit figure itself is fractional. INR groups and places its
 * symbol the Indian way regardless of the interface language, because these
 * figures are quotes a customer compares against an Indian price list.
 */
export function formatRate(minorUnits: number, currency: string | null | undefined): string {
    const code = String(currency || "usd").toUpperCase();
    const amount = Number(minorUnits || 0) / 100;
    const fractionDigits = Number.isInteger(Number(minorUnits || 0)) ? 2 : 4;
    try {
        return new Intl.NumberFormat(code === "INR" ? "en-IN" : "en-US", {
            style: "currency",
            currency: code,
            minimumFractionDigits: 2,
            maximumFractionDigits: fractionDigits,
        }).format(amount);
    } catch {
        return `${amount.toFixed(fractionDigits)} ${code}`;
    }
}

/** The symbol alone, for input adornments. */
export function currencySymbol(currency: string | null | undefined): string {
    return String(currency || "usd").toLowerCase() === "inr" ? "₹" : "$";
}

/** Blank means "not set"; anything else is major units (rupees or dollars). */
export function minorFromMajorInput(input: string): number | null {
    const trimmed = input.trim();
    if (trimmed === "") return null;
    return Math.round(Number(trimmed) * 100);
}

export function majorInputFromMinor(minor: number | null | undefined): string {
    return minor === null || minor === undefined ? "" : (minor / 100).toFixed(2);
}
